module.exports = __webpack_public_path__ + "static/media/heart.b422e180.svg";